import { render, staticRenderFns } from "./InformationStudentListNew.vue?vue&type=template&id=06541951&scoped=true"
import script from "./InformationStudentListNew.vue?vue&type=script&lang=js"
export * from "./InformationStudentListNew.vue?vue&type=script&lang=js"
import style0 from "./InformationStudentListNew.vue?vue&type=style&index=0&id=06541951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06541951",
  null
  
)

export default component.exports